export const FREE_GIFTS = [
  {
    id: 'coconut-foot-mask',
    name: 'Coconut Moisturizing & Repair Foot Mask',
    tagline: 'Full of essence · Deep repair',
    image: 'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/du6040bj_coconut%20foot%20mask%20description.jpg',
    description: 'Coconut extract + trehalose foot mask. Intensely moisturizing for soft, repaired feet.',
    accent: 'orange',
  },
  {
    id: 'tea-tree-foot-mask',
    name: 'Tea Tree Mint Exfoliating Foot Mask',
    tagline: 'Gentle exfoliation · Soft, tender feet',
    image: 'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/gkufc6sp_trea%20mint%20foot%20mask.jpg',
    description: 'Tea tree + mint exfoliating foot mask. Refreshes and gently buffs away dryness.',
    accent: 'green',
  },
];
